import React, { useEffect, useRef, useState } from "react";
// Import partner logos
import Partner1 from "../assets/Partner1.png";
import Partner2 from "../assets/Partner2.png";
import Partner3 from "../assets/Partner3.png";
import Partner4 from "../assets/Partner4.png";
import Partner7 from "../assets/Partner7.png";
import Partner8 from "../assets/Partner8.png";
import Partner9 from "../assets/Partner9.png";
import Partner10 from "../assets/Partner10.png";
import Partner11 from "../assets/Partner11.png";
import Partner13 from "../assets/Partner13.png";
import Partner14 from "../assets/Partner14.png";
import Partner15 from "../assets/Partner15.png";
import Partner16 from "../assets/Partner16.png";
import Partner18 from "../assets/Partner18.png";
import Partner19 from "../assets/Partner19.png";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import Picture from "../assets/Picture.png";
import line from "../assets/line.png";
import Integrated from "../assets/Integrated.png";
import First from "../assets/First.jpg";
import RotatingCircle from "./RotatingCircle";
import AnimatedCircle from "./AnimatedCircle";
import ColourLogo from "../assets/ColourLogo.svg";
import { Link } from "react-router-dom"; // ✅ Add this line
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import AnimatedHeadings from '../components/AnimatedHeadings'; // adjust path if needed
import { Phone, Mail } from "lucide-react";
import OurPartnersCarousel from "./OurPartnersCarousel"; 

const useFadeInOnScroll = () => {
  const ref = useRef();
useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("appear");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const el = ref.current;
    if (el) {
      observer.observe(el);
    }

    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);

  return ref;
};
const partners = [
    Partner1, Partner2, Partner3, Partner4, 
    Partner7, Partner8, Partner9, Partner10,
    Partner11, Partner13, Partner14, Partner15,
    Partner16, Partner18, Partner19,
  ];
 const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 5,   // ⭐ ALWAYS 5 LOGOS
  slidesToScroll: 1,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 2000,
  cssEase: "linear",
  arrows: false,
  pauseOnHover: false,
  responsive: [
    { breakpoint: 1280, settings: { slidesToShow: 5 } },
    { breakpoint: 1024, settings: { slidesToShow: 5 } },
    { breakpoint: 768, settings: { slidesToShow: 5 } },
    { breakpoint: 480, settings: { slidesToShow: 5 } },
  ],
};

// Section component with full width
// Section component with full width
const Section = ({ children, className = "" }) => {
  const ref = useFadeInOnScroll();
 
  return (
    <section
      ref={ref}
      className={`snap-start h-screen w-screen flex items-center justify-center ${className}`}
    >
      {children}
    </section>
  );
};

const LandingPage = () => {
  const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 600) {
        setSlidesToShow(5);
      } else {
        setSlidesToShow(3);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [scrolling, setScrolling] = useState(false);
  const [circleRef, inView] = useInView({ threshold: 0.5, triggerOnce: true });
   
const handleScroll = () => {
    if (!scrolling) {
      setScrolling(true); // Set scrolling to true to prevent immediate next scroll
      setTimeout(() => setScrolling(false), 1000); // Delay for 1 second, then allow scrolling again
    }
  };
  
  const stats = [
    { value: 10  , label: 'YEARS OF \nEXPERIENCE' },
    { value: 40 , label: 'TRAINED \nMODELS' },
    { value: 5 , label: 'GEOGRAPHICAL \nLOCATIONS' },
  ];

  // This function will handle counting from 1 to the target number
  const Counter = ({ targetValue }) => {
    const [count, setCount] = useState(1);  // Start counting from 1

    useEffect(() => {
      let start = 1;
      const end = targetValue;
      const duration = 5; // Duration for counting (in seconds)
      const increment = Math.ceil((end - start) / (duration * 100)); // Smooth increment for the animation

      const timer = setInterval(() => {
        setCount((prevCount) => {
          if (prevCount < end) {
            return prevCount + increment; // Increment the number
          } else {
            clearInterval(timer); // Stop when the target is reached
            return end;
          }
        });
      }, 1000 / 60); // Update every 1/60th of a second for smooth animation

      return () => clearInterval(timer); // Cleanup the interval when the component is unmounted
    }, [targetValue]);

   return <motion.span>{Math.floor(count)}+</motion.span>;
  };

  return (
    <div className="bg-white text-gray-800 scroll-smooth snap-y snap-mandatory mt-0 mb-0 py-0 overflow-hidden">
  <section className="relative w-screen h-screen overflow-hidden text-white">
  {/* Background video */}
  <video
    src="/Landing1080.mp4"
    autoPlay
    muted
    loop
    playsInline
    controls={false}
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
  />

  {/* Gradient overlay */}
  <div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />

<div className="absolute inset-0 z-0 opacity-50 pointer-events-none">
  <svg viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg"
       className="w-full h-full" preserveAspectRatio="xMidYMid meet">
    <defs>
      <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#c471ed" />
        <stop offset="100%" stopColor="#12c2e9" />
      </linearGradient>
    </defs>
    <g transform="translate(-50,-40) rotate(-20, 250, 250)">
      <path d="M180,280 C150,190 300,100 480,140 C660,180 680,320 540,400 C400,480 240,440 180,280Z" fill="url(#grad3)" opacity="0.2"/>
    </g>
    <g transform="translate(250,100) rotate(20, 520, 360)">
      <path d="M520,380 C600,240 740,220 820,340 C900,460 760,540 600,520 C440,500 460,460 520,380Z" fill="url(#grad3)" opacity="0.2"/>
    </g>
  </svg>
</div>



  {/* Content wrapper */}
  <div className="relative w-full h-full z-20 flex flex-col justify-center items-center min-h-screen px-4 sm:px-6">
    <div className="w-full flex flex-col justify-center items-center text-center">
      <div className="w-full h-full">
        <AnimatedHeadings />
      </div>
    </div>

    <div className="absolute bottom-6 sm:bottom-10 lg:bottom-12 right-4 sm:right-8 lg:right-10 xl:right-12 2xl:right-16">
  <Link
    to="/about"
    onClick={() => (window.location.href = "/about")}
    className="px-6 py-3 border border-white text-white rounded-md 
               hover:bg-purple-50 hover:text-black font-medium text-base sm:text-lg transition-colors duration-200"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    Know more
  </Link>
</div>


  </div>
</section>


<section
  className="w-screen flex justify-center items-center overflow-hidden bg-white relative mt-4 mb-4 sm:mt-6 sm:mb-6"
  style={{
    height: "auto",
    minHeight: "fit-content",
    paddingTop: "3rem",
    paddingBottom: "3rem",
  }}
>
  <div className="w-full flex justify-center p-0 m-0">
    <div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full items-center gap-8 sm:gap-10 px-6 lg:pl-12 lg:pr-8 m-0"
      style={{ alignItems: "center" }}
    >
      {/* Column 1: Stats */}
     <div
  className="flex flex-col items-center gap-6 m-0 p-0 leading-none relative"
  style={{ left: "-5rem" }}
>
        {stats.map((stat, index) => (
          <div className="text-center m-0 p-0" key={index}>
            <h1
              className="font-extrabold text-transparent leading-tight mb-0 p-0"
              style={{
                fontFamily: "Calibri, sans-serif",
                fontSize: "2.7rem",
                letterSpacing: "0.05em",
                WebkitTextStroke: "2px #9c6bff",
              }}
            >
              <Counter targetValue={stat.value} />
            </h1>
            <p className="font-bold text-[#9c6bff] mt-1 mb-0 p-0 text-base sm:text-lg text-center whitespace-pre-line">
              {stat.label}
            </p>
          </div>
        ))}
      </div>

{/* Column 1: Stats (no change) */}

{/* Column 2: Ball */}
<div
  ref={circleRef}
  className="ball-column-mobile flex justify-center items-center lg:h-full m-0 p-0 leading-none
  lg:-ml-48 lg:-translate-x-6 xl:translate-x-0 order-2 lg:order-none mt-4 lg:mt-0"
>
  <RotatingCircle animate={inView} className="ball-responsive-img" />
</div>


{/* Column 3: Paragraph */}
<div
  className="
    paragraph-container-mobile flex flex-col items-start justify-center w-full m-0 p-0 leading-none
    lg:-translate-x-20 xl:-translate-x-24 order-3
  "
>
  {/* (Heading + paragraph + button unchanged) */}




  {/* Heading + underline (slightly more left) */}
  <div className="inline-block m-0 p-0 w-fit transform -translate-x-2 lg:-translate-x-6">
   <h2 className="text-lg sm:text-xl lg:text-2xl font-semibold text-black whitespace-nowrap mt-0 mb-1 leading-tight
  lg:w-[130%] lg:-translate-x-5 xl:w-auto xl:translate-x-0">



      <span className="text-black mr-1">For</span>
      <span className="text-[#00CFFF] mr-1">Ethical</span>
      <span className="text-black mr-1">and</span>
      <span className="text-[#00CFFF] mr-1">Data-Driven</span>
      <span className="text-black">Innovation</span>
    </h2>
    <img src={line} alt="underline" className="h-[6px] w-full mt-1 mb-0" />
  </div>

<p
  className="text-gray-700 text-[26px] leading-relaxed tracking-normal mt-2 text-justify
  lg:w-[142%] lg:-translate-x-9 xl:w-auto xl:-translate-x-6"
>
  Wissenstil is a forward-thinking startup specializing in Artificial Intelligence.
  Committed to innovation, we focus on developing intelligent solutions for the
  Healthcare, Lifesciences, and Aerospace sectors. Our dedicated team is constantly
  pushing boundaries to solve complex challenges in Machine Vision and Data
  Intelligence.
</p>




<div className="mt-6 mb-0 w-full relative ml-8 -mt-2">
  <Link
  to="/about"
  onClick={() => (window.location.href = "/about")}
  className="
    absolute 
    right-[-2.5rem] sm:right-[-2.75rem] lg:right-[-3rem]

    top-[-3rem]
    xl:top-[-2.5rem]
    2xl:top-[-3rem]

    px-6 py-3 border-2 border-purple-500 text-purple-600 rounded-md 
    bg-white

    hover:bg-[#4B0082] hover:text-white hover:border-[#4B0082]

    font-semibold text-base sm:text-lg 
    transition-all duration-200
  "
  style={{ fontFamily: 'Calibri, sans-serif' }}
>
  Know More
</Link>

</div>

      </div>
    </div>
  </div>
</section>

{/* Hero2 */}
<section
  className="w-screen h-auto mt-0 mb-0 snap-start bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white relative overflow-hidden py-28"
  style={{ paddingLeft: "2rem" }}
>
  <div className="w-full flex flex-col justify-center items-center px-4 sm:px-6 lg:px-12">
    <div className="flex flex-col md:flex-row justify-between items-center gap-12 w-full max-w-7xl mx-auto">

     
      {/* Left Section: Circles + Text */}
      <div className="flex flex-col items-center md:items-start gap-8 flex-1"
        style={{ marginLeft: "-2rem" }} // ✅ Moves only the left content slightly right
      >

        <div className="flex flex-row justify-center md:justify-start gap-12">
          {/* 72% Circle */}
          <div className="flex flex-col items-center text-center space-y-3">
            <AnimatedCircle
              percentage={72}
              size={140}
              strokeWidth={16}
              strokeColor="#9C6BFF"
              trailColor="#6e00dcff"
              textColor="#FFFFFF"
            />
            <p
              className="font-medium leading-snug text-base sm:text-lg md:text-[24px]"
              style={{ fontFamily: 'Calibri, sans-serif' }}
            >
              Of businesses <br /> now integrate AI <br /> into operations
            </p>
          </div>

          {/* 40% Circle */}
          <div className="flex flex-col items-center text-center space-y-3">
            <AnimatedCircle
              percentage={40}
              size={140}
              strokeWidth={16}
              strokeColor="#9C6BFF"
              trailColor="#6e00ddff"
              textColor="#FFFFFF"
            />
            <p
              className="font-medium leading-snug text-base sm:text-lg md:text-[24px]"
              style={{ fontFamily: 'Calibri, sans-serif' }}
            >
              Boost in productivity <br /> with AI automation
            </p>
          </div>
        </div>

        {/* CTA Text */}
<p
  className="text-lg max-lg:text-3xl sm:text-2xl md:text-3xl font-semibold whitespace-nowrap 
             text-center md:text-left mt-6"
  style={{ fontFamily: 'Calibri, sans-serif' }}
>
  Stay ahead — embrace AI today!
</p>

</div>

<div className="flex-1 flex flex-col items-start text-left ml-0 md:ml-4">
  <h2
    className="font-extrabold text-transparent mb-6 whitespace-nowrap"
    style={{
      fontFamily: "Calibri, sans-serif",
      fontSize: "2.5rem",
      lineHeight: "1.3",
      letterSpacing: "0.05em",
      WebkitTextStroke: "1.5px white",
    }}
  >
    Transform your Business
  </h2>
<ul className="space-y-4 text-base sm:text-lg md:text-[24px]">
  {[
    "AI-powered software applications",
    "Predictive maintenance",
    "Computer vision-based process automation",
    "AI-powered threat detection & security",
    "AI-driven simulation for precision engineering",
  ].map((item, i) => (
    <li
      key={i}
      className="transition-transform duration-300 hover:translate-x-2 flex items-start text-xl"
    >
      <span className="text-purple-400 mr-2 text-[26px]">•</span>
      <span className="text-[26px]">{item}</span>
    </li>
  ))}
</ul>



      </div>
    </div>
  </div>

 {/* Bottom-right Button */}
<div
  className="absolute bottom-6 sm:bottom-10 lg:bottom-12 right-0"
  style={{ right: '2rem' }}
>


  <Link
    to="/contact"
    onClick={() => (window.location.href = "/contact")}
    className="px-6 py-3 border border-white text-white rounded-md 
               hover:bg-purple-50 hover:text-black font-medium text-base sm:text-lg transition-colors duration-200"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    Contact Us
  </Link>
</div>
</section>


<section className="w-screen h-auto min-h-0 mt-0 mb-0 snap-start bg-white relative overflow-hidden flex items-center px-0 sm:px-0 lg:px-0 py-24 m-0">
  <div className="max-w-7xl w-full mx-auto">  {/* REMOVE text-center */}

    {/* Heading */}
    <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 flex-wrap">

   <motion.h1
  className="font-extrabold mt-4 text-transparent"
  style={{
    fontFamily: "Calibri, sans-serif",
    WebkitTextStroke: "3px #9c6bff",
    WebkitTextFillColor:
      !window.matchMedia("(hover: hover)").matches &&
      window.matchMedia("(min-width: 1024px)").matches
        ? "#9c6bff"  // Mobile Desktop-Site → purple fill
        : "transparent", // Laptop + normal mobile → no fill
    fontSize: "5rem",
    lineHeight: "1.1",
    letterSpacing: "0.05em",
  }}
>
  WISE
</motion.h1>

      <motion.h2
        className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 leading-snug md:leading-tight max-w-2xl text-center md:text-left"
      >
        The AI Engine Behind Smarter <br className="hidden md:block" />
        Solutions and Seamless Services
      </motion.h2>

    </div>

    {/* Paragraph */}
   <p
  className="mt-8 text-gray-700 leading-relaxed max-w-2xl mx-auto text-[26px] text-center"
  style={{ fontFamily: 'Calibri, sans-serif' }}
>
  Our intelligent AI framework seamlessly integrates advanced
  analytics, automation, and machine learning to drive efficiency,
  precision, and innovation across industries.
</p>




    {/* BUTTON ROW — IMPORTANT FIX */}
     <div className="absolute bottom-6 sm:bottom-10 lg:bottom-10 right-0 pr-6">
  <Link
  to="/about"
  className="
    inline-block px-6 py-3 border border-purple-400 text-purple-600 rounded-md
    bg-white
    hover:bg-[#4B0082] hover:text-white hover:border-[#4B0082]
    font-semibold text-base sm:text-lg
    transition-transform duration-200
  "
  style={{ fontFamily: 'Calibri, sans-serif' }}
>
  Know More
</Link>
</div>

  </div>
</section>




{/* Product Suite */}
{/* Product Suite */}

<section className="w-screen h-auto min-h-0 mt-0 mb-0 snap-start  
    bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] 
    text-white relative overflow-hidden px-0 py-20">

  <div className="max-w-6xl w-full mx-auto flex flex-col justify-center h-auto px-4 sm:px-6 md:px-8">

    {/* Heading */}
<div className="mb-8 pl-2 sm:pl-4 md:pl-6">
  <h2 className="text-left text-2xl sm:text-3xl font-semibold text-white mb-2">
    <span className="text-blue-300">WISE</span> Powered Product Suite
  </h2>
  <img src={line} alt="line" className="h-[6px] w-auto mt-1" />
</div>


    {/* Image + Text */}
    <div className="
        grid grid-cols-1 md:grid-cols-2 
        gap-10 md:gap-20 
        items-center
        w-full">

      {/* LEFT — IMAGE */}
      <div className="flex justify-center md:justify-start">
        <motion.img
          src={Picture}
          alt="WISE Product Suite"
          className="
            w-[60vw] max-w-[240px] 
            sm:w-[50vw] sm:max-w-[280px] 
            md:w-[38vw] md:max-w-[320px]
            lg:w-auto lg:max-w-sm 
            h-auto z-10"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        />
      </div>

      {/* RIGHT — TEXT */}
      <div className="flex flex-col items-start justify-center max-w-xl">
       <p
  className="text-white text-[26px] leading-relaxed mb-4 text-left"
  style={{ fontFamily: 'Calibri, sans-serif' }}
>
  Built on the power of WISE, our product suite enhances operational 
  efficiency and data-driven decision-making. Key offerings include:
</p>



        <ul
          className="list-disc pl-6 space-y-3 marker:text-blue-300 text-white"
          style={{ fontFamily: 'Calibri, sans-serif' }}
        >
          <li className="text-base sm:text-lg md:text-[26px]">
            Hospital Information System (HIS)
          </li>
          <li className="text-base sm:text-lg md:text-[26px]">
            Electronic Health Records (EHR)
          </li>
          <li className="text-base sm:text-lg md:text-[26px]">
            Revenue Cycle Management (RCM)
          </li>
        </ul>
      </div>
    </div>

    {/* Button */}
<div className="absolute bottom-6 sm:bottom-10 lg:bottom-12 right-[1.6rem] sm:right-[2rem] lg:right-[2.4rem]">
  <Link
    to="/products"
    onClick={() => (window.location.href = "/products")}
    className="px-6 py-3 border border-white text-white rounded-md 
               hover:bg-purple-50 hover:text-black font-medium text-base sm:text-lg"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    Know more
  </Link>
</div> 






  </div>
</section>


<section
  className="
    w-screen bg-white
    pt-4 sm:pt-6 md:pt-8
    pb-0
    px-4 sm:px-6 lg:px-8
    !h-auto !min-h-0 !max-h-none
  "
>
  <div className="max-w-6xl mx-auto flex flex-col">

    {/* GRID FIX — prevents overlap */}
    <div
  className="
    grid 
    grid-cols-1 
    md:grid-cols-2 
    gap-10 md:gap-16 
    items-start
    h-fit
  "
>

     {/* LEFT: TEXT BLOCK */}
<div className="w-full min-h-max block">
 <p
  className="text-gray-800 mb-6 text-lg sm:text-xl md:text-[26px]"
  style={{ fontFamily: 'Calibri, sans-serif', lineHeight: '1.5' }}
>
  Leveraging the WISE framework, our AI-powered
  services drive precision and automation in critical domains:
</p>


  <ul
    className="list-disc pl-5 space-y-3 marker:text-blue-300 text-gray-800"
    style={{ fontFamily: 'Calibri, sans-serif', fontSize: '26px' }}
  >
    {['ECG Analysis', 'Radiology Assist', 'Patient Engagement', 'Security & Defense']
      .map((item, index) => (
        <li key={index} className="transition-transform duration-300 hover:translate-x-2">
          {item}
        </li>
      ))}
  </ul>
</div>


      {/* RIGHT: HEADING + IMAGE */}
      <div className="flex flex-col items-center md:items-start">

       <h2 className="text-2xl sm:text-3xl font-semibold mb-4 text-center md:text-left">
  <div className="relative inline-block pb-1">
    <span className="relative z-10">
      <span className="text-[#00cfff]">WISE</span>{' '}
      <span className="text-black">Integrated Services</span>
    </span>
    <img
      src={line}
      alt="underline"
      className="absolute left-0 bottom-0 h-[6px] w-full object-contain"
    />
  </div>
</h2>

        <motion.img
          src={Integrated}
          alt="WISE Integrated Services"
          className="
            w-full 
            max-w-xs 
            sm:max-w-sm 
            md:max-w-md 
            lg:max-w-sm 
            h-auto
          "
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 2 }}
          viewport={{ once: true }}
        />
      </div>

    </div>

    {/* Button */}
{/* Button */}
{/* Button */}
{/* Button */}
{/* Button */}
<div className="w-full mt-10 flex justify-end">
  <Link
  to="/services"
  className="
    inline-block px-6 py-3 border border-purple-400 text-purple-600 rounded-md
    bg-white
    hover:bg-[#4B0082] hover:text-white hover:border-[#4B0082]
    font-semibold text-base sm:text-lg
    transition-transform duration-200
    mr-0
    xl:translate-x-[150px]
  "
  style={{ fontFamily: 'Calibri, sans-serif' }}
>
  Know More
</Link>
</div>










  </div>
</section>


<div className="flex justify-center mt-4 sm:mt-6 md:mt-8">
  <h2 className="text-4xl sm:text-5xl font-bold text-[#6F7DFF] mb-10 text-center">
    Empowering Success with Clients and Partners
  </h2>
</div>

<section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden h-auto">
  {/* Partner logos inside gradient */}
  <div className="w-full max-w-[1480px] mx-auto px-4 mt-[1.2rem] mb-[1.5rem]">
 <Slider {...settings}>
  {partners.map((logo, index) => (
    <div
      key={index}
      className="flex justify-center items-center px-2 sm:px-6 md:px-10"
    >
      <img
        src={logo}
        alt={`Partner ${index + 1}`}
        className="
          h-14 sm:h-20 md:h-32 lg:h-40
          object-contain
          grayscale hover:grayscale-0 
          opacity-90 hover:opacity-100 
          transition duration-500
        "
      />
    </div>
  ))}
</Slider>

</div>


  {/* White curved part */}
  {/* White curved part */}
{/* White curved part */}
{/* White curved part */}
<div className="absolute top-[180px] left-0 w-full">
  <div
    className="
      bg-white
      rounded-t-[12rem]
      sm:rounded-t-[14rem]
      h-[600px]            /* ⬅ increased height */
      sm:h-[6400px]
      md:h-[6800px]
      pb-10
    "
  ></div>
</div>
 
{/* Content */}
<div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-10 pb-16">
 
  {/* Top heading */}
  <div className="text-center mt-[10px] mb-12">  {/* ⬅ moved up from 160px */}
    <h2 className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]">
      Collaborate for Success
    </h2>
    <p className="text-gray-700 text-lg sm:text-xl font-medium">
      Working together with others fosters innovation, creativity, and a greater sense of accomplishment.
    </p>
  </div>
 
 
    {/* Four-column footer part */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">
      {/* About Us */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
        <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
      <p className="mb-4 leading-relaxed">
  Wissenstil Solutions is a specialized software company driving digital innovation.
</p>
      </div>
 
      {/* Services */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
        <ul className="space-y-2">
          <li>Image Analysis</li>
          <li>Anomaly Detection</li>
          <li>Medical Coding</li>
        </ul>
      </div>
 
 
{/* Useful Links */}
<div>
  <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
  <ul
    className="space-y-2 text-gray-800"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    {[
      { name: "About Us", path: "/about" },
      { name: "Wise Services", path: "/services" },
      { name: "Wise Products", path: "/products" },
      { name: "Contact Us", path: "/contact" },
    ].map((link, index) => (
      <li
        key={index}
        className="transition-transform duration-300 hover:translate-x-2 text-base sm:text-lg md:text-xl"
      >
        <Link
          to={link.path}
          onClick={() => (window.location.href = link.path)}
          className="relative inline-block hover:text-purple-700 transition-colors duration-200 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-purple-700 hover:after:w-full after:transition-all after:duration-300"
        >
          {link.name}
        </Link>
      </li>
    ))}
  </ul>
</div>
 
      {/* Contact */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
        <p>
          Wissenstil Solutions Private Ltd.<br />
          Brigade IRV Centre, 09th &amp; 10th Floor,<br />
          Nallurahalli, Whitefield,<br />
          Bangalore, 560066.
        </p>
     
 
<div className="mt-4 space-y-3 text-white">
  <p className="flex items-center space-x-3">
    <Phone className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">+91 9986158307</span>
  </p>
  <p className="flex items-center space-x-3">
    <Mail className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">Manish.palliyil@wissenstil.com</span>
  </p>
</div>
      </div>
    </div>
  </div>
</section>
 
 
 
    </div>
  );
};
 
export default LandingPage;